import fetchJson from '../../fetchJson';
import ShopifyApiError from '../ShopifyApiError';
import customErrorHandler from '../customErrorHandler';

/**
 * Clears the Cart!
 *
 * Removes all contents of the cart, but does not remove cart attributes or the cart note.
 * @returns {Promise<any | Error>} Promise for response json
 */
const clearCart = () => {
  return fetchJson({
    url: `${window.Shopify.routes.root}cart/clear.js`,
    customErrorHandler,
    bypassErrors: [ShopifyApiError],
    config: {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json;',
      },
    },
  });
};

export default clearCart;
